import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a0fb322"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["xlink:href"];
const _hoisted_2 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _mergeProps({
    class: "svg-icon",
    "aria-hidden": "true"
  }, _ctx.$attrs, {
    preserveAspectRatio: "none"
  }), [!$setup.isImg ? (_openBlock(), _createElementBlock("use", {
    key: 0,
    "xlink:href": $setup.iconName
  }, null, 8, _hoisted_1)) : (_openBlock(), _createElementBlock("image", {
    key: 1,
    width: "100%",
    height: "100%",
    href: $setup.iconName
  }, null, 8, _hoisted_2))], 16);
}